export default "__VITE_ASSET__9BfpCXy4__"